/**
 * @generated SignedSource<<34abc622a1bf92de3984502e014f7e59>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatChannelMessageActionsFragment$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"usePermissionsFragment">;
  readonly " $fragmentType": "ChatChannelMessageActionsFragment";
};
export type ChatChannelMessageActionsFragment$key = {
  readonly " $data"?: ChatChannelMessageActionsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatChannelMessageActionsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatChannelMessageActionsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePermissionsFragment"
    }
  ],
  "type": "ChatChannel",
  "abstractKey": null
};

(node as any).hash = "a4090d1fdd9145d114e749686afef5dd";

export default node;
